import { EXECUTE_USER_LOGIN, EXECUTE_USER_LOGOUT, SET_WX_JS_URL, SET_NAVIGATION_TITLE, SET_AUTH_TB_ACCOUNT_INFO } from '@/store/mutation-types'
import LocalStore from '@/utils/localStore'
import Consts from '@/common/consts'
import Cookie from '@/utils/cookie'
import { getDefaultUserInfo } from '@/utils/help'

export default {
  [EXECUTE_USER_LOGIN]: (state, data) => {
    // 登录
    state.mobile = data.mobile
    state.token = data.token
    state.userInfo = data
    state.userUnionID = data.secondLevelDomainID
    LocalStore.set(Consts.CART_NAME, data.cart) // 从远程服务器获取购物车数据,覆盖本地数据
    state.cart.cartStoreList = data.cart // 刷新本地state中的购物车数据
  },
  [EXECUTE_USER_LOGOUT]: state => {
    // 退出登录
    state.token = ''
    state.userInfo = getDefaultUserInfo()
    state.userUnionID = ''
    state.authTbAccountName = ''
    state.authTbAccountRelationId = ''
  },
  [SET_WX_JS_URL]: (state, url) => {
    // 设置进入微信时jssdk所需的URL
    state.jsUrl = url
  },
  [SET_NAVIGATION_TITLE]: (state, data) => {
    // 设置进入webapp时的标题和来源URL
    state.navigationTitle = data.title
    state.fromSourceUrl = data.fromSourceUrl
  },
  [SET_AUTH_TB_ACCOUNT_INFO]: (state, data) => {
    // 设置授权的淘宝账户信息
    state.authTbAccountName = data.tbAccountName
    state.authTbAccountRelationId = data.tbRelationId
    Cookie.set(Consts.COOKIE_AUTH_TB_ACCOUNT_NAME, data.tbAccountName)
    Cookie.set(Consts.COOKIE_AUTH_TB_ACCOUNT_RELATION_ID, data.tbRelationId)
  },
}
